import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MasterTableEditWarning } from '../MasterTableEditWarning';
import { ExpenditurePurposeOfSettlementStatisticsPresetForm } from './ExpenditurePurposeOfSettlementStatisticsPresetForm';

type Props = ComponentProps<
  typeof ExpenditurePurposeOfSettlementStatisticsPresetForm
>;

export const ExpenditurePurposeOfSettlementStatisticsPresetFormDrawer: FC<
  Props
> = ({ type, initialValues, onSubmit }) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={
        drawerState.open &&
        drawerState.type ===
          'expenditure-purpose-of-settlement-statistics-preset'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {type === 'edit' && <MasterTableEditWarning marginBottom={8} />}
      <ExpenditurePurposeOfSettlementStatisticsPresetForm
        type={type}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
